import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=4fe937a9&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=4fe937a9&prod&scoped=true&lang=css&external"
import style1 from "./BottomBar.vue?vue&type=style&index=1&id=4fe937a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe937a9",
  null
  
)

export default component.exports